import { render, staticRenderFns } from "./Playground.vue?vue&type=template&id=2ac353a3&"
import script from "./Playground.vue?vue&type=script&lang=ts&"
export * from "./Playground.vue?vue&type=script&lang=ts&"
import style0 from "./Playground.vue?vue&type=style&index=0&id=2ac353a3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports